import React, { useEffect, useMemo, useState } from "react";
import "./BasesEstaleiroPage.css";
import PerfilTrilhosBase from "./perfil-trilhos/PerfilTrilhosBase";
import FabricantesEstaleiroBase from "./fabricantes/FabricantesEstaleiroBase";
import ClassesEstaleiroBase from "./classes/ClassesEstaleiroBase";
import MotivoDefeitoNovoBase from "./motivo-defeito/MotivoDefeitoBase";
import MotivoDefeitoReempregoBase from "./motivo-defeito-reemprego/MotivoDefeitoReempregoBase";
import VagoesBase from "./vagoes/VagoesBase";
import OrigemCarregamentoTrilhosNovosBase from "./origem-carregamento-trilhos-novos/OrigemCarregamentoTrilhosNovosBase";
import OrigemCarregamentoTrilhosReempregoBase from "./origem-carregamento-trilhos-reemprego/OrigemCarregamentoTrilhosReempregoBase";

const HOME_VIEW_ID = "home_bases_estaleiro";
const STORAGE_KEY = "pai4.basesEstaleiro.moduloSelecionado";

const MODULO_ICONS = {
  home_bases_estaleiro: "🏠",
  perfil_trilhos: "🛤️",
  origens_carregamento_trilhos_novos: "📦",
  origens_carregamento_trilhos_reemprego: "♻️",
  fabricantes: "🏭",
  classes: "🏷️",
  motivos_defeito_novo: "⚠️",
  motivos_defeito_reemprego: "🔁",
  vagoes: "🚃",
};

const MODULOS_BASE = [
  {
    id: "perfil_trilhos",
    titulo: "Perfis de Trilho",
    descricao: "Base compartilhada entre Cadastro de Trilhos Novos e Reemprego.",
    ativo: true,
  },
  {
    id: "origens_carregamento_trilhos_novos",
    titulo: "Origens - Trilhos Novos",
    descricao: "Cadastro de origem de carregamento para o recebimento de trilhos novos.",
    ativo: true,
  },
  {
    id: "origens_carregamento_trilhos_reemprego",
    titulo: "Origens - Trilhos Reemprego",
    descricao: "Cadastro de origem de carregamento para o recebimento de trilhos de reemprego.",
    ativo: true,
  },
  {
    id: "fabricantes",
    titulo: "Fabricantes",
    descricao: "Cadastro base de fabricante e modelo dos trilhos.",
    ativo: true,
  },
  {
    id: "classes",
    titulo: "Classes",
    descricao: "Cadastro base de classe e subclasse dos trilhos.",
    ativo: true,
  },
  {
    id: "motivos_defeito_novo",
    titulo: "Motivos de Defeito Novo",
    descricao: "Cadastro base de motivos de defeito para trilhos novos.",
    ativo: true,
  },
  {
    id: "motivos_defeito_reemprego",
    titulo: "Motivos de Defeito Reemprego",
    descricao: "Cadastro base de motivos de defeito para trilhos de reemprego.",
    ativo: true,
  },
  {
    id: "vagoes",
    titulo: "Vagões",
    descricao: "Cadastro base de códigos de vagão.",
    ativo: true,
  },
];

function getSavedModule() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (!saved) return HOME_VIEW_ID;
    if (saved === HOME_VIEW_ID) return HOME_VIEW_ID;
    return MODULOS_BASE.some((modulo) => modulo.id === saved) ? saved : HOME_VIEW_ID;
  } catch {
    return HOME_VIEW_ID;
  }
}

function ModuloButton({ id, titulo, descricao, ativo = true, selected, onClick }) {
  return (
    <button
      type="button"
      className={`bes-modulo-btn ${selected ? "is-selected" : ""}`}
      onClick={onClick}
    >
      <span className="bes-modulo-icon" aria-hidden="true">
        {MODULO_ICONS[id] || "•"}
      </span>
      <span className="bes-modulo-main">
        <span className="bes-modulo-title">{titulo}</span>
        <span className="bes-modulo-desc">{descricao}</span>
        {!ativo ? <span className="bes-chip">Em implantação</span> : null}
      </span>
      <span className="bes-modulo-arrow" aria-hidden="true">
        ›
      </span>
    </button>
  );
}

function BasesEstaleiroHome({ onSelectModulo }) {
  const totalAtivos = MODULOS_BASE.filter((modulo) => modulo.ativo).length;

  return (
    <section className="bes-home-panel bes-home">
      <div className="bes-home-hero">
        <div className="bes-home-hero-content">
          <div className="bes-home-hero-text">
            <span className="bes-home-pill">Bases do Estaleiro</span>
            <h3>Central de cadastros operacionais do estaleiro</h3>
            <p>
              Acesse rapidamente as bases compartilhadas de trilhos, origens, vagões,
              fabricantes e classificações sem sair do mesmo fluxo.
            </p>
            <div className="bes-home-hero-kpis">
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">{MODULOS_BASE.length}</span>
                <span className="bes-home-hero-kpi-label">Módulos</span>
                <span className="bes-home-hero-kpi-note">Catálogo centralizado de bases</span>
              </div>
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">{totalAtivos}</span>
                <span className="bes-home-hero-kpi-label">Ativos</span>
                <span className="bes-home-hero-kpi-note">Prontos para uso nas telas do estaleiro</span>
              </div>
              <div className="bes-home-hero-kpi">
                <span className="bes-home-hero-kpi-value">1</span>
                <span className="bes-home-hero-kpi-label">Hub</span>
                <span className="bes-home-hero-kpi-note">Entrada única para manutenção das bases</span>
              </div>
            </div>
          </div>

          <div className="bes-home-hero-panel">
            <span className="bes-home-panel-title">Acesso rápido</span>
            <div className="bes-home-panel-grid">
              {MODULOS_BASE.slice(0, 4).map((modulo, index) => (
                <button
                  key={modulo.id}
                  type="button"
                  className="bes-home-panel-card"
                  onClick={() => onSelectModulo(modulo.id)}
                >
                  <span className="bes-home-panel-value">{index + 1}</span>
                  <span className="bes-home-panel-label">{modulo.titulo}</span>
                </button>
              ))}
            </div>
            <span className="bes-home-panel-foot">
              Selecione um módulo na lateral ou use os atalhos acima.
            </span>
          </div>
        </div>
      </div>

      <div className="bes-home-section">
        <div className="bes-home-section-head">
          <div>
            <h4>Módulos disponíveis</h4>
            <p>As bases abaixo alimentam diretamente as telas operacionais do estaleiro.</p>
          </div>
        </div>

        <div className="bes-home-modules-list">
          {MODULOS_BASE.map((modulo) => (
            <button
              key={modulo.id}
              type="button"
              className="bes-home-module-item"
              onClick={() => onSelectModulo(modulo.id)}
            >
              <span className="bes-home-module-icon" aria-hidden="true">
                {MODULO_ICONS[modulo.id] || "•"}
              </span>
              <span className="bes-home-module-copy">
                <strong>{modulo.titulo}</strong>
                <p>{modulo.descricao}</p>
              </span>
              <span className={`bes-home-status ${modulo.ativo ? "is-active" : "is-pending"}`}>
                {modulo.ativo ? "Ativo" : "Pendente"}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function BasesEstaleiroPage({ onBack }) {
  const [moduloSelecionado, setModuloSelecionado] = useState(getSavedModule);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, moduloSelecionado);
    } catch {}
  }, [moduloSelecionado]);

  const moduloAtivo = useMemo(
    () => MODULOS_BASE.find((modulo) => modulo.id === moduloSelecionado) || null,
    [moduloSelecionado]
  );

  function goBack() {
    if (onBack) onBack();
    else if (window.history.length > 1) window.history.back();
    else window.location.href = "/";
  }

  return (
    <main className="bes-page">
      <div className="bes-root">
        <aside className="bes-sidebar">
          <button type="button" className="bes-back" onClick={goBack}>
            Menu Principal
          </button>

          <section className="bes-side-card">
            <h3>Módulos</h3>
            <div className="bes-modulos">
              <ModuloButton
                id={HOME_VIEW_ID}
                titulo="Home das Bases"
                descricao="Visão geral dos módulos de cadastro do estaleiro."
                selected={moduloSelecionado === HOME_VIEW_ID}
                onClick={() => setModuloSelecionado(HOME_VIEW_ID)}
              />

              {MODULOS_BASE.map((modulo) => (
                <ModuloButton
                  key={modulo.id}
                  id={modulo.id}
                  titulo={modulo.titulo}
                  descricao={modulo.descricao}
                  ativo={modulo.ativo}
                  selected={moduloSelecionado === modulo.id}
                  onClick={() => setModuloSelecionado(modulo.id)}
                />
              ))}
            </div>
          </section>
        </aside>

        <section className="bes-content">
          <header className="bes-header">
            <div className="bes-header-copy">
              <h1>Bases do Estaleiro</h1>
              <p className="bes-subtitle">{moduloAtivo?.titulo || "Home das Bases"}</p>
            </div>
          </header>

          <div className="bes-module-shell">
            {moduloSelecionado === HOME_VIEW_ID ? (
              <BasesEstaleiroHome onSelectModulo={setModuloSelecionado} />
            ) : null}

            {moduloAtivo && !moduloAtivo.ativo ? (
              <div className="bes-placeholder">
                <h3>{moduloAtivo.titulo}</h3>
                <p>{moduloAtivo.descricao}</p>
                <small>Este módulo será habilitado nas próximas entregas de bases.</small>
              </div>
            ) : null}

            {moduloAtivo?.id === "perfil_trilhos" ? <PerfilTrilhosBase /> : null}
            {moduloAtivo?.id === "fabricantes" ? <FabricantesEstaleiroBase /> : null}
            {moduloAtivo?.id === "classes" ? <ClassesEstaleiroBase /> : null}
            {moduloAtivo?.id === "motivos_defeito_novo" ? <MotivoDefeitoNovoBase /> : null}
            {moduloAtivo?.id === "motivos_defeito_reemprego" ? <MotivoDefeitoReempregoBase /> : null}
            {moduloAtivo?.id === "vagoes" ? <VagoesBase /> : null}
            {moduloAtivo?.id === "origens_carregamento_trilhos_novos" ? (
              <OrigemCarregamentoTrilhosNovosBase />
            ) : null}
            {moduloAtivo?.id === "origens_carregamento_trilhos_reemprego" ? (
              <OrigemCarregamentoTrilhosReempregoBase />
            ) : null}
          </div>
        </section>
      </div>
    </main>
  );
}
